import { Checkbox } from 'antd';
import { useFormikContext } from 'formik';
import useSmartField from 'hooks/useSmartField';
import { useTranslate } from '@tolgee/react';
import { FV, GatherContainer } from './share';
import WaitReply from './WaitReply';

const cancelOrderScenarios: Remind.CancelOrderScenario[] = [
  'cancelledTradeChangeVoucher',
  'cancelledTradeModifyOrder',
  'cancelledTradeChangeMind',
  'cancelledTradeFoundCheaper',
  'cancelledTradeTooTroublesome',
  'cancelledTradeOthers',
  'cancellingTradeChangeAddress',
  'cancellingTradeModifyOrder',
  'cancellingTradeOthers',
  'cancellingTradeIrresponding',
];

function CancelOrderField() {
  const { t } = useTranslate();

  const scenarioLabelMap: Record<Remind.CancelOrderScenario, string> = {
    cancelledTradeChangeVoucher: t('refundSetting.修改优惠券'),
    cancelledTradeModifyOrder: t('aide.修改订单'),
    cancelledTradeChangeMind: t('aide.不想买了'),
    cancelledTradeFoundCheaper: t('aide.在别处找到更便宜的'),
    cancelledTradeTooTroublesome: t('aide.付款程序太麻烦'),
    cancelledTradeOthers: t('aide.其他'),
    cancellingTradeChangeAddress: t('refundSetting.修改收货地址'),
    cancellingTradeModifyOrder: t('aide.修改已有订单'),
    cancellingTradeOthers: t('aide.其他改变主意'),
    cancellingTradeIrresponding: t('aide.卖家不响应咨询'),
  };

  const {
    values: {
      orderAbandonGroup: { enable },
    },
  } = useFormikContext<FV>();

  const {
    field: { value, onChange },
  } = useSmartField<
    FV['orderAbandonGroup']['remindScene']['CANCEL_ORDER_RETRIEVE']['cancelOrderRetrieveConfig']
  >('orderAbandonGroup.remindScene.CANCEL_ORDER_RETRIEVE.cancelOrderRetrieveConfig');

  const disabled = !enable || cancelOrderScenarios.every((scenario) => !value[scenario]);

  const { waitReply, closeCondition } = value;

  const { cancelled, notInCancelAndNotCancelled } = closeCondition;

  return (
    <GatherContainer>
      <h4>{t('aide.取消订单挽回')}</h4>
      <div>
        <h5>{t('remind.选择x场景', { x: t('aide.取消订单挽回') })}</h5>
        {cancelOrderScenarios.map((scenario) => {
          const { [scenario]: checked } = value;

          const { [scenario]: label } = scenarioLabelMap;

          return (
            <Checkbox
              key={scenario}
              disabled={!enable}
              checked={checked}
              onChange={({ target: { checked } }) => {
                onChange({
                  ...value,
                  [scenario]: checked,
                });
              }}
            >
              {label}
            </Checkbox>
          );
        })}
      </div>
      <WaitReply
        waitReply={waitReply}
        onWaitReplyChange={(waitReply) => onChange({ ...value, waitReply })}
        disabled={disabled}
      />
      <div>
        <h5>{t('remind.自动关闭当前会话的重要提醒')}</h5>
        <div>
          <Checkbox
            disabled={disabled}
            checked={notInCancelAndNotCancelled}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  notInCancelAndNotCancelled: checked,
                },
              })
            }
          >
            {t('remind.买家撤回 或 卖家拒绝取消订单申请')}
          </Checkbox>
          <Checkbox
            disabled={disabled}
            checked={cancelled}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  cancelled: checked,
                },
              })
            }
          >
            {t('remind.取消订单申请已通过')}
          </Checkbox>
        </div>
      </div>
    </GatherContainer>
  );
}

export default CancelOrderField;
